import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import ActivitiesView from '@/components/activities/activities-view'
import { loadCrmPageProps } from '@/lib/crm-page'

const ActivitiesPage: FC<Partial<CrmPageProps>> = ({ data, today }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Activities" description="Calls, emails, meetings, tasks and notes across every account.">
            <PageHeader title="Activities" />
            <ActivitiesView />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<CrmPageProps> = async () => {
    return { props: await loadCrmPageProps() }
}

export default ActivitiesPage
